import urlApi from '../../router/urlApi'
import urlApiV2 from '../../router/urlApiV2'
import { Serialize } from '../../services/serializeFormData'
import Vue from 'vue'
import router from '../../router'

const toastOptions = {
  theme: 'none',
  position: 'bottom-center',
  className: 'vuestic-toast',
  iconPack: 'fontawesome',
  duration: 5000
}

// Vue.use(Toast, toastOptions)
export default {
  startTime () {
    let self = this
    var time = new Date()
    var y = time.getFullYear()
    var mon = time.getMonth() + 1
    var d = time.getDate()
    var h = time.getHours()
    var min = time.getMinutes()
    var s = time.getSeconds()

    mon = self.checktime(mon)
    d = self.checktime(d)
    h = self.checktime(h)
    min = self.checktime(min)
    s = self.checktime(s)

    var now = d + '/' + mon + '/' + y + '   ' + h + ':' + min + ':' + s

    if (document.getElementById('clock')) {
      document.getElementById('clock').innerHTML = now
    }

    setTimeout(function () {
      self.startTime()
    }, 1000)
  },
  checktime (i) {
    if (i.toString().length < 2) {
      i = '0' + i
    }
    return i
  },
  	// CARREGAR AUTO ESCOLAS
	async loadCfc () {
		let selectCFC = [
			{ value: '', text: 'SELECIONE UMA AUTO ESCOLA' },
		]

		Vue.http.get(urlApiV2 + '/autoescola').then(response => {
			response.data.dados.map(autoescolas => {
				if (autoescolas.nome_fantasia !== 'TESTE') {
					selectCFC.push({
						value: autoescolas.tenant_schema,
						text: autoescolas.nome_fantasia,
					})
				}
			})
		})

		return selectCFC
	},

  storeFoto () {
    // let self = this

    Vue.http.post(urlApi + '/aulas/praticas/anotacao', Serialize.withFormData('form_fotos_teoricas')).then((response) => {
      console.log(response)
    }).catch((response) => {
      console.log(response)
    })
  },

  launchToast (icon, msg) {
    Vue.toasted.show(msg, {
      icon: icon,
      position: 'top-right',
      duration: 5000,
      fullWidth: false
    }
    )
  },

  getAula (callback, sala) {
    let self = this
    var time = new Date()
    // var time = new Date(2019, 3, 1, 15, 50, 0, 0);
    var y = time.getFullYear()
    var mon = time.getMonth() + 1
    var d = time.getDate()
    var h = time.getHours()
    var min = time.getMinutes()
    var s = time.getSeconds()

    mon = self.checktime(mon)
    d = self.checktime(d)
    h = self.checktime(h)
    min = self.checktime(min)
    s = self.checktime(s)

    var now = d + '-' + mon + '-' + y + '   ' + h + ':' + min + ':' + s

    Vue.http.get(urlApi + '/aulas/teoricas/cfc/' + sala.cfc + '/sala/' + sala.id + '/foto/' + now).then((response) => {
      // console.log(response)
      callback(response.data.dados)
    }).catch((response) => {
      console.log(response)
    })
  },

  getAulaTeorica (callback, sala) {
    Vue.http.get(urlApi + '/aulas/teoricas/cfc/' + sala.cfc + '/sala/' + sala.id).then((response) => {
      // console.log(response)
      callback(response.data.dados)
    }).catch((response) => {
      // console.log(response)
    })
  },

  getAulaPresencial (callback, sala, schema) {
    Vue.http.get(urlApi + '/aulas/teoricas/presenciais/' + schema + '/sala/' + sala.id).then((response) => {
      callback(response.data.dados)
    }).catch((response) => {
    })
  },

  getAulasTeoricas (callback, sala, schema) {
    Vue.http.get(urlApi + '/aulas/teoricas/' + schema +  '/sala/' + sala.id).then((response) => {
      callback(response.data.dados)
    }).catch((response) => {
    })
  },

  getEntidades (callback, sala) {
    Vue.http.get(urlApi + '/aulas/teoricas/cfc/' + sala.cfc + '/sala/' + sala.id).then((response) => {
      callback(response.data.dados)
    }).catch((response) => {
      console.log(response)
    })
  },

  getSalas (callback) {
    Vue.http.get(urlApi + '/aulas/salas').then((response) => {
      console.log(response)
      callback(response.data)
    })
  },

  getSalasPresenciais (callback) {
    Vue.http.get(urlApi + '/aulas/salas/presenciais/page').then((response) => {
      callback(response.data)
    })
  },

  getAulasPresenciais (callback, schema) {
    Vue.http.get(urlApi + '/aulas/salas/presencial/' + schema + '/show').then((response) => {
      callback(response.data)
    })
  },

  getSalasVirtuais (callback) {
    Vue.http.get(urlApi + '/aulas/salas/virtual/page').then((response) => {
      callback(response.data)
    })
  },

  getAulasVirtuais (callback, schema) {
    Vue.http.get(urlApi + '/aulas/salas/virtual/' + schema + '/show').then((response) => {
      callback(response.data)
    })
  },

  getAulas (callback, schema, periodo) {
    Vue.http.get(urlApiV2 + '/aulas/teoricas/monitoramento?schema=' + schema + '&periodo='+ periodo).then((response) => {
      callback(response.data)
    })
  },

  getPhotos (callback, schema, turma) {
    Vue.http.get(urlApiV2 + '/aulas/teoricas/monitoramento/fotos?schema=' + schema + '&turma='+ turma).then((response) => {
      callback(response.data)
    })
  },

  getFotoInstrutor (callback, idInstrutor, schema) {
   Vue.http.get(urlApiV2 + '/instrutor/detalhes/' + idInstrutor + '/' + schema).then((response) => {
     callback(response.data)
    })
  },

  getFotoAluno (callback, idAluno, schema) {
    Vue.http.get(urlApiV2 + '/alunos/consultar/detalhes/' + idAluno + '/' + schema).then((response) => {
      callback(response.data)
    })
  },

  getFotoAluno (callback, idAluno, schema) {
    Vue.http.get(urlApiV2 + '/alunos/consultar/detalhes/' + idAluno + '/' + schema).then((response) => {
      callback(response.data)
      console.log(callback)
    })
  },

  getTurmas (callback) {
    Vue.http.get(urlApi + '/turmas').then((response) => {
      callback(response.data)
    })
  },

  updateFoto (idFotoTeorica, idStatus) {
    Vue.http.get(urlApi + '/aulas/teoricas/fotos/' + idFotoTeorica + '/' + idStatus).then((response) => {
      console.log(response)
    }).catch((response) => {
      console.log(response)
    })
  },

  removeFoto (instanciaVue, cfc, id_turma_teorica, id_aula_teorica, idFotoTeorica) {

    let self = this;

    Vue.http.post(urlApi + '/aulas/teoricas/removerFoto', {'cfc' : cfc, 'turma' : id_turma_teorica, 'aula' : id_aula_teorica, 'foto' : idFotoTeorica}
    ).then((response) => {

      instanciaVue.atualizar();

      if(instanciaVue.$refs.smallModal)
        instanciaVue.$refs.smallModal.close()

      self.launchToast('fa-check', response.body.mensagem);

    }).catch((response) => {
      self.launchToast('fa-exclamation-triangle', response.body.mensagem);
    })
  },

  updateFotoEntidadeInstrutor (idInstrutor, idStatus, idAulaTeorica) {
    Vue.http.get(urlApi + '/aulas/teoricas/aula/instrutor/' + idInstrutor + '/' + idStatus + '/' + idAulaTeorica).then((response) => {
      console.log(response)
    }).catch((response) => {
      console.log(response)
    })
  },

  updateFotoEntidade (idAluno, idStatus, idAulaTeorica) {
    Vue.http.get(urlApi + '/aulas/teoricas/aula/aluno/' + idAluno + '/' + idStatus + '/' + idAulaTeorica).then((response) => {
      console.log(response)
    }).catch((response) => {
      console.log(response)
    })
  },

  updateFotoTodas (idAula, type) {
    Vue.http.get(urlApi + '/aulas/teoricas/classificar/aula/' + idAula + '/' + type).then((response) => {
      console.log(response)
    }).catch((response) => {
      console.log(response)
    })
  },

  getRelatorio (callback) {
    // let self = this

    Vue.http.post(urlApi + '/aulas/teoricas/relatorio', Serialize.withFormData('form_relatorio')).then((response) => {
      callback(response.data.dados)
    }).catch((response) => {
      console.log(response)
    })
  },
  abrirSala (idSala, Schema) {
    router.push({name: 'abrir-sala', params: { id: idSala.id, schema : Schema } })
  },

  abrirSalaPresenciais (idSala, Schema) {
    router.push({name: 'abrir-presenciais', params: { id: idSala.id, schema: Schema} })
  },
}
